import { CTAForm } from "../Form/CTAForm";
import { LabelButton } from "../buttons/LabelButton/LabelButton";
import "./formSections.css";

export const CTAFormSection = () => {
  return (
    <div className="feedback">
      <div className="feedback-left-side">
        <LabelButton>GET IN TOUCH</LabelButton>
        <div className="yields">
          <h2>
            Increase
            <br /> <span className="color-text">yields</span> with us
          </h2>
        </div>
      </div>
      <CTAForm />
    </div>
  );
};
